import { YandexMetrikaAbTestModule } from '@analytics/feature';
import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MobileMenuItemComponent, MobileMenuStepComponent, SdvorTabBarItemComponent } from '@sdvor/shared/ui';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { UrlModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { ComparisonComponent } from './comparison.component';

@NgModule({
  imports: [
    RouterLink,
    AsyncPipe,
    NgIf,
    IconModule,
    MobileMenuItemComponent,
    MobileMenuStepComponent,
    UrlModule,
    SdvorTabBarItemComponent,
    SdvorIconComponent,
    YandexMetrikaAbTestModule,
  ],

  declarations: [ComparisonComponent],
  exports: [ComparisonComponent],
})
export class ComparisonModule {}
